var N = /* @__PURE__ */ ((n) => (n[n.EMPORIUM = 0] = "EMPORIUM", n[n.INVENTORY = 1] = "INVENTORY", n[n.OTHERS_INVENTORY = 2] = "OTHERS_INVENTORY", n[n.FAVORITE = 3] = "FAVORITE", n[n.POPUP_SELECT_FOR_STAR_ATTACH = 4] = "POPUP_SELECT_FOR_STAR_ATTACH", n))(N || {}), I = /* @__PURE__ */ ((n) => (n[n.NONE = 0] = "NONE", n[n.INVENTORY_NORMAL = 1] = "INVENTORY_NORMAL", n[n.INVENTORY_LISTING = 2] = "INVENTORY_LISTING", n[n.INVENTORY_ATTACH = 3] = "INVENTORY_ATTACH", n))(I || {}), O = /* @__PURE__ */ ((n) => (n[n.MiniBlackHole = 0] = "MiniBlackHole", n[n.Sun = 1] = "Sun", n[n.Asteroid = 2] = "Asteroid", n[n.Comet = 3] = "Comet", n[n.Supernova = 4] = "Supernova", n[n.ApostleTicket = 5] = "ApostleTicket", n[n.Gift = 6] = "Gift", n[n.BattlePass = 7] = "BattlePass", n[n.Emblem = 8] = "Emblem", n[n.CommunityItem = 9] = "CommunityItem", n))(O || {}), l = /* @__PURE__ */ ((n) => (n.Astronomical = "Astronomical", n.BreedingRelic = "Breeding", n.Item = "Item", n))(l || {});
const t = "#dd8a0e", A = {
  agingBuff: 0,
  balanceInfo: null,
  cheapestListingInfo: null,
  disabled: {
    message: "",
    value: !1
  },
  id: "0",
  image: "",
  listingInfo: null,
  metadata: {
    dataType: "Item"
    /* Item */
  },
  name: "",
  orbitTrack: 0,
  selected: 0,
  tier: null,
  typeInfo: null
}, E = {
  COLOR: {
    AGING: {
      BUFF: "#e71c80",
      BUFF_NAME: "#fe5a36"
    },
    ORBITAL_TRACK: {
      BUFF: "#57b04f",
      BUFF_NAME: "#78a5ff"
    }
  }
};
export {
  E as ASTRONOMICAL_BUFF,
  t as DEFAULT_FILTER_TAG_COLOR,
  A as EmptyGodiverse,
  I as GodiverseCardType,
  N as GodiverseListMode,
  l as GodiverseMetadataType,
  O as GodiverseType
};
//# sourceMappingURL=godiverse.js.map
